import React, { useEffect, useState, useRef } from 'react';
import unsplash from '../api/unsplash';

import clsx from 'clsx';
import {
    ArrowDropUp,
    Error as ErrorIcon,
    CheckCircle as CheckCircleIcon,
    InsertDriveFile as InsertDriveFileIcon,
    ArrowDropDown as ArrowDropDownIcon,
    Download,
    Upload,
} from '@mui/icons-material';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';

import {
    Autocomplete,
    Box,
    IconButton,
    CircularProgress,
    Dialog,
    DialogContentText,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    DialogActions,
    MenuItem,
    Card,
    Grid,
    CardContent,
    Zoom,
    Switch,
    FormControlLabel,
    LinearProgress,
    Tabs,
    Tab,
    Tooltip,
    ButtonGroup,
} from '@mui/material';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import {
    Add,
    Delete,
    Circle,
    Edit,
    Close,
    Check,
    Work,
    AccountCircle,
} from '@mui/icons-material';
import GlobalSnackbar from './Snackbar';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const AnagraficaCorsi = () => {
    const [corsi, setCorsi] = useState([]);
    const [corsiVisibili, setCorsiVisibili] = useState([]);
    const [clientiOptions, setClientiOptions] = useState([]);

    const [loading, setLoading] = useState(true);
    const [openSnack, setOpenSnack] = useState(false);
    const [value, setValue] = useState(0);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const [filtro, setFiltro] = useState({
        nonAttivi: false,
        attivi: true,
    });
    const visibilitaLimitata =
        String(sessionStorage.getItem('VisibilitaLimitata')) === '1';
    const columnsELearning = [
        {
            filterable: false,
            field: 'Azioni',
            headerName: 'Azioni',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <>
                    <NewCorsoModal
                        myFunction={handleSaveData}
                        title="Modifica corso"
                        corsi={corsi}
                        clientiOptions={clientiOptions}
                        requireClientiAssociation={visibilitaLimitata}
                        setSnack={setSnack}
                        setOpenSnack={setOpenSnack}
                        operation="Edit"
                        corsoSel={params.row}
                    />
                </>
            ),
        },
        {
            filterable: false,
            field: 'AttestatoCustom',
            headerName: 'Attestato custom',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <AttestatoCustomActions
                    corso={params.row}
                    onChange={reloadData}
                    setSnack={setSnack}
                    setOpenSnack={setOpenSnack}
                />
            ),
        },

        /*{    field: "Attivo",
      headerName: "Attivo",
      width: 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => (
        <Circle sx={{ color: params.row.Attivo === 1 ? "#40C18F" : "#FF2768" }}>
          {" "}
        </Circle>
      ),
    },
    {
      field: "IncludiNelPianoFormazione",
      headerName: "Formazione",
      width: 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => (
        <Circle
          sx={{
            color:
              params.row.IncludiNelPianoFormazione === 1
                ? "#40C18F"
                : "#FF2768",
          }}
        >
          {" "}
        </Circle>
      ),
    },*/
        {
            field: 'Codice',
            headerName: 'Codice',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },

        {
            field: 'Scadenza',
            headerName: 'Scadenza',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DurataAggiornamento',
            headerName: 'Durata Aggiornamento (ore)',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];
    const columns = [
        {
            filterable: false,
            field: 'Azioni',
            headerName: 'Azioni',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <>
                    <NewCorsoModal
                        myFunction={handleSaveData}
                        title="Modifica corso"
                        corsi={corsi}
                        clientiOptions={clientiOptions}
                        requireClientiAssociation={visibilitaLimitata}
                        setSnack={setSnack}
                        setOpenSnack={setOpenSnack}
                        operation="Edit"
                        corsoSel={params.row}
                    />
                    <DeleteDialog
                        corso={params.row}
                        myFunction={handleDelete}
                    />
                </>
            ),
        },
        {
            filterable: false,
            field: 'AttestatoCustom',
            headerName: 'Attestato custom',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <AttestatoCustomActions
                    corso={params.row}
                    onChange={reloadData}
                    setSnack={setSnack}
                    setOpenSnack={setOpenSnack}
                />
            ),
        },
        {
            field: 'Attivo',
            headerName: 'Attivo',
            width: 70,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => (
                <Circle
                    sx={{
                        color: params.row.Attivo === 1 ? '#40C18F' : '#FF2768',
                    }}
                >
                    {' '}
                </Circle>
            ),
        },
        {
            field: 'IncludiNelPianoFormazione',
            headerName: 'Formazione',
            width: 70,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => (
                <Circle
                    sx={{
                        color:
                            params.row.IncludiNelPianoFormazione === 1
                                ? '#40C18F'
                                : '#FF2768',
                    }}
                >
                    {' '}
                </Circle>
            ),
        },
        {
            field: 'Codice',
            headerName: 'Codice',
            //width: 400,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Durata',
            headerName: 'Durata (ore)',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Scadenza',
            headerName: 'Scadenza',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DurataAggiornamento',
            headerName: 'Durata Aggiornamento (ore)',
            //width: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const handleSaveData = async (corso, operazione, clienti = []) => {
        try {
            //AGGIUNGERE LA CREAZIONE DELLA SEDE

            if (operazione === 'new') {
                const response = await unsplash.post(
                    'anagraficaCorsi',
                    { corso: corso, clienti: clienti },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                if (response.data?.error) {
                    setSnack({
                        severity: 'warning',
                        messaggio: response.data.message,
                    });
                    setOpenSnack(true);
                    return;
                }
                setSnack({
                    severity: 'success',
                    messaggio: 'Corso creato con successo',
                });
                setOpenSnack(true);
            } else {
                await unsplash.put(
                    'anagraficaCorsi',
                    { corso: corso },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                setSnack({
                    severity: 'success',
                    messaggio: 'Corso modificato con successo',
                });
                setOpenSnack(true);
            }
            await reloadData();
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                'Errore durante la creazione del corso';
            setSnack({
                severity: 'error',
                messaggio: errorMessage,
            });
            setOpenSnack(true);
        }
    };

    const importDataFromPiGreco = async () => {
        //function to import data from pigreco
        try {
            await unsplash.post(
                'pigreco/corsi',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
        } catch (error) {
            console.error(error);
        }
    };

    const reloadData = async () => {
        try {
            let response = await unsplash.get('anagraficaCorsi', {
                params: {
                    getAll: true,
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            setCorsi(response.data.data);
            setCorsiVisibili(
                response.data.data.filter((el) => el.Attivo === 1)
            );

            setLoading(false);
        } catch (error) {
            console.error(error.message);
        }
    };

    const loadClienti = async () => {
        try {
            const response = await unsplash.get('clienti', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });
            setClientiOptions(response.data.data || []);
        } catch (error) {
            console.error(error.message);
        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        // è un loop qui carico i dati
        (async () => {
            await importDataFromPiGreco();
            await reloadData();
            await loadClienti();
        })();
    }, []);

    const handleDelete = async (codice) => {
        try {
            await unsplash.delete('anagraficaCorsi', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                data: {
                    codice: codice,
                },
            });

            let response = await unsplash.get('anagraficaCorsi', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            setCorsi(response.data.data);
            setCorsiVisibili(response.data.data);

            setSnack({
                severity: 'success',
                messaggio: 'Corso eliminato con successo',
            });
            setOpenSnack(true);
        } catch (error) {
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante la cancellazione',
            });
            setOpenSnack(true);
        }
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.attivi}
                                onChange={(e) => filter(e, 'attivi')}
                            />
                        }
                        label="Attivi"
                    />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.nonAttivi}
                                onChange={(e) => filter(e, 'nonAttivi')}
                            />
                        }
                        label="Non attivi"
                    />
                </Grid>
            </GridToolbarContainer>
        );
    }

    function CustomToolbarELearning() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.attivi}
                                onChange={(e) => filter(e, 'attivi')}
                            />
                        }
                        label="Attivi"
                    />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.nonAttivi}
                                onChange={(e) => filter(e, 'nonAttivi')}
                            />
                        }
                        label="Non attivi"
                    />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const filter = (e, tipologia) => {
        let f = { ...filtro };
        f[tipologia] = e.target.checked;
        setFiltro(f);

        let corsiTemp = corsi;

        if (!f.nonAttivi) {
            corsiTemp = corsiTemp.filter((c) => c.Attivo !== 0);
        }

        if (!f.attivi) {
            corsiTemp = corsiTemp.filter((c) => c.Attivo !== 1);
        }
        setCorsiVisibili(corsiTemp);
    };

    const handelOpenELearning = async () => {
        try {
            let responseCorso = await unsplash.post(
                'pigreco/getLink',
                { id: sessionStorage.getItem('idUsername') },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            let link = responseCorso.data.link;
            // Open a new tab or page
            const newWindow = window.open(link, '_blank');

            // Ensure newWindow exists and is open before setting listeners
            if (newWindow) {
                // Set up a listener to detect when user returns to the app
                window.onfocus = async () => {
                    await reloadFromPigreco();

                    // Clean up the listener after triggering
                    window.onfocus = null;
                };
            }
            //window.open(link, "_blank");
        } catch (error) {
            console.log(error);
        }
    };

    const reloadFromPigreco = async () => {
        // This function will execute when the user returns to the app
        await importDataFromPiGreco();
        await reloadData();
        // You can add other actions here, like updating state or data
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                variant="scrollable"
            >
                <Tab icon={<Work />} iconPosition="start" label="Corsi" />
                <Tab
                    icon={<AccountCircle />}
                    iconPosition="start"
                    label="E-Learning"
                />
            </Tabs>
            <TabPanel
                value={value}
                index={0}
                style={{
                    marginTop: '5px',
                    backgroundColor: '#11526F',
                    borderRadius: '5px',
                }}
            >
                <Grid item xs={12}>
                    <Card sx={{ boxShadow: 'none' }}>
                        <CardContent>
                            <Grid
                                container
                                direction="row"
                                spacing={2}
                                alignItems="center"
                                justifyContent="flex-end"
                            >
                                <Grid item xs={12} md={5}>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="flex-end"
                                    >
                                        <NewCorsoModal
                                            myFunction={handleSaveData}
                                            title="Crea nuovo corso"
                                            corsi={corsi}
                                            clientiOptions={clientiOptions}
                                            requireClientiAssociation={
                                                visibilitaLimitata
                                            }
                                            setSnack={setSnack}
                                            setOpenSnack={setOpenSnack}
                                            operation="new"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div>
                                <center>
                                    <div
                                        className="mb-4 form-outline input-group"
                                        style={{ width: '33%' }}
                                    >
                                        <span className="bg-transparent input-group-text">
                                            <i className="bi bi-search"></i>
                                        </span>
                                        <input
                                            onChange={handleChange}
                                            className="form-control form-control-lg border-left-0"
                                        />
                                    </div>
                                </center>
                            </div>

                            <Box
                                sx={{
                                    height: {
                                        xs: '75vh',
                                        md: '60vh',
                                        xl: '75vh',
                                    },
                                    width: 1,
                                }}
                            >
                                <DataGridPro
                                    sx={{ fontSize: 12 }}
                                    components={{
                                        Toolbar: CustomToolbar,
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                    }}
                                    loading={loading}
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    rows={corsiVisibili.filter(
                                        (el) => el.IDCorsoPiGreco == null
                                    )}
                                    columns={columns}
                                    getRowId={(row) => row.Codice}
                                    pageSize={100}
                                    initialState={{
                                        sorting: {
                                            sortModel: [
                                                {
                                                    field: 'Cognome',
                                                    sort: 'ASC',
                                                },
                                            ],
                                        },
                                        pinnedColumns: { left: ['Azioni'] },
                                    }}
                                    disableSelectionOnClick
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </TabPanel>

            {/* PAnel E-learning */}
            <TabPanel
                value={value}
                index={1}
                style={{
                    marginTop: '5px',
                    backgroundColor: '#11526F',
                    borderRadius: '5px',
                }}
            >
                <Grid item xs={12}>
                    <Card sx={{ boxShadow: 'none' }}>
                        <CardContent>
                            <Grid
                                container
                                direction="row"
                                spacing={2}
                                alignItems="center"
                                justifyContent="flex-end"
                            >
                                <Grid item xs={12} md={4}>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="flex-end"
                                    >
                                        <Button
                                            startIcon={<Add />}
                                            onClick={handelOpenELearning}
                                            sx={{ color: 'white' }}
                                            variant="outlined"
                                            className="ButtonMiller"
                                        >
                                            Crea Corso
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Box
                                sx={{
                                    height: {
                                        xs: '75vh',
                                        md: '60vh',
                                        xl: '75vh',
                                    },
                                    width: 1,
                                }}
                            >
                                <DataGridPro
                                    sx={{ fontSize: 12 }}
                                    components={{
                                        Toolbar: CustomToolbarELearning,
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                    }}
                                    loading={loading}
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    rows={corsiVisibili.filter(
                                        (el) => el.IDCorsoPiGreco != null
                                    )}
                                    columns={columnsELearning}
                                    getRowId={(row) => row.Codice}
                                    pageSize={100}
                                    initialState={{
                                        sorting: {
                                            sortModel: [
                                                {
                                                    field: 'Cognome',
                                                    sort: 'ASC',
                                                },
                                            ],
                                        },
                                        pinnedColumns: { left: ['Azioni'] },
                                    }}
                                    disableSelectionOnClick
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </TabPanel>
        </>
    );
};

const NewCorsoModal = (props) => {
    const [open, setOpen] = useState(false);
    const [corso, setCorso] = useState();
    const [validation, setValidation] = useState();
    const [clientiSelezionati, setClientiSelezionati] = useState([]);
    const [codeSuggestion, setCodeSuggestion] = useState(null);

    const handleClickOpen = () => {
        setValidation({ Nome: false, Cognome: false, CF: false, eMail: false });
        if (props.operation === 'new') {
            setCorso({
                Codice: '',
                Descrizione: '',
                Durata: '',
                Scadenza: '',
                DurataAggiornamento: '',
                Ordinamento: '',
                Attivo: 1,
                IncludiNelPianoFormazione: 1,
                PeriodicitaAggiornamento: 0,
            });
            setClientiSelezionati([]);
            setCodeSuggestion(null);
        } else {
            setCorso(props.corsoSel);
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        let c = { ...corso };
        c[e.target.name] = e.target.value;
        setCorso(c);
    };

    useEffect(() => {
        if (!open || props.operation !== 'new') {
            return undefined;
        }

        const timeout = setTimeout(async () => {
            try {
                const response = await unsplash.get(
                    'anagraficaCorsi/suggest-code',
                    {
                        params: {
                            query: corso?.Codice || '',
                            description: corso?.Descrizione || '',
                        },
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                setCodeSuggestion(response.data?.data || null);
            } catch (error) {
                setCodeSuggestion(null);
            }
        }, 300);

        return () => clearTimeout(timeout);
    }, [open, props.operation, corso?.Codice, corso?.Descrizione]);

    const handleSave = async () => {
        if (props.operation === 'new') {
            let filter = props.corsi.filter((c) => c.Codice === corso.Codice);

            if (filter.length > 0) {
                props.setSnack({
                    severity: 'warning',
                    messaggio: "Attenzione l'azienda esiste già",
                });
                props.setOpenSnack(true);
                return;
            }
            if (clientiSelezionati.length === 0) {
                props.setSnack({
                    severity: 'warning',
                    messaggio: 'Seleziona almeno una società',
                });
                props.setOpenSnack(true);
                return;
            }
        }
        const clientiIds = clientiSelezionati.map((cliente) => cliente.ID);
        props.myFunction(corso, props.operation, clientiIds);
    };

    return (
        <div>
            {props.operation === 'Edit' ? (
                <IconButton
                    aria-label="edit"
                    onClick={handleClickOpen}
                    sx={{ p: 0 }}
                >
                    <Edit
                        style={{
                            height: '2rem',
                            width: '2rem',
                            color: '#2265B1',
                        }}
                    />
                </IconButton>
            ) : (
                <div className="flex flex-row items-center justify-center">
                    <Button
                        startIcon={<Add />}
                        onClick={handleClickOpen}
                        sx={{ color: 'white' }}
                        variant="outlined"
                        className="ButtonMiller"
                    >
                        Crea Corso
                    </Button>
                    &nbsp;
                    {/* upload presenze */}
                    <UploadPresenze />
                </div>
            )}

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ mx: 'auto' }}>{props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            fullWidth
                        >
                            Attivo:
                            <Switch
                                checked={corso?.Attivo === 1}
                                onChange={(e) => {
                                    let c = { ...corso };
                                    c.Attivo = c.Attivo === 1 ? 0 : 1;
                                    setCorso(c);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            fullWidth
                        >
                            Piano Formazione:
                            <Switch
                                checked={corso?.IncludiNelPianoFormazione === 1}
                                onChange={(e) => {
                                    let c = { ...corso };
                                    c.IncludiNelPianoFormazione =
                                        c.IncludiNelPianoFormazione === 1
                                            ? 0
                                            : 1;
                                    setCorso(c);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            fullWidth
                        >
                            Periodicità Aggiornamento
                            <Switch
                                checked={corso?.PeriodicitaAggiornamento === 1}
                                onChange={(e) => {
                                    setCorso({
                                        ...corso,
                                        PeriodicitaAggiornamento:
                                            corso.PeriodicitaAggiornamento === 1
                                                ? 0
                                                : 1,
                                    });
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="dense"
                                name="Codice"
                                label="Codice"
                                type="text"
                                fullWidth
                                value={corso?.Codice}
                                disabled={props.operation === 'Edit'}
                                onChange={handleChange}
                                variant="outlined"
                                helperText={
                                    codeSuggestion?.latestCode
                                        ? `Ultimo codice della famiglia: ${codeSuggestion.latestCode}`
                                        : validation?.Nome
                                          ? 'Campo obbligatorio'
                                          : 'Scrivi Safety, HR o una descrizione compliance per ricevere un suggerimento'
                                }
                                inputProps={{ maxLength: 25 }}
                            />
                            {props.operation === 'new' &&
                                codeSuggestion?.suggestedCode &&
                                corso?.Codice !==
                                    codeSuggestion.suggestedCode && (
                                    <Button
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                        onClick={() =>
                                            setCorso({
                                                ...corso,
                                                Codice:
                                                    codeSuggestion.suggestedCode,
                                            })
                                        }
                                    >
                                        Usa {codeSuggestion.suggestedCode}
                                    </Button>
                                )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="dense"
                                name="Descrizione"
                                label="Descrizione"
                                type="text"
                                fullWidth
                                value={corso?.Descrizione}
                                onChange={handleChange}
                                variant="outlined"
                                helperText={
                                    validation?.Cognome
                                        ? 'Campo obbligatorio'
                                        : ''
                                }
                            />
                        </Grid>
                        {props.operation === 'new' && (
                            <Grid item xs={12}>
                                <Autocomplete
                                    multiple
                                    options={props.clientiOptions || []}
                                    value={clientiSelezionati}
                                    onChange={(event, value) =>
                                        setClientiSelezionati(value)
                                    }
                                    getOptionLabel={(option) =>
                                        option?.RagioneSociale || ''
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option.ID === value.ID
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Società associate"
                                            placeholder="Seleziona società"
                                            helperText={
                                                clientiSelezionati.length === 0
                                                    ? 'Campo obbligatorio'
                                                    : ''
                                            }
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                        <hr
                            style={{
                                height: '2px',
                                marginTop: '10px',
                                marginBottom: '5px',
                                width: '100%',
                                marginLeft: '16px',
                            }}
                        />
                        <Grid item xs={12} md={3}>
                            <TextField
                                margin="dense"
                                name="Durata"
                                label="Durata (ore)"
                                type="number"
                                fullWidth
                                value={corso?.Durata}
                                onChange={handleChange}
                                variant="outlined"
                                helperText={
                                    validation?.CF ? 'Campo obbligatorio' : ''
                                }
                                inputProps={{ maxLength: 16, step: '0.25' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                margin="dense"
                                name="Scadenza"
                                label="Scadenza (anni)"
                                type="number"
                                fullWidth
                                disabled={corso?.PeriodicitaAggiornamento === 1}
                                value={corso?.Scadenza}
                                onChange={handleChange}
                                variant="outlined"
                                helperText={
                                    validation?.eMail
                                        ? 'Campo obbligatorio'
                                        : ''
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                margin="dense"
                                name="DurataAggiornamento"
                                label="Durata Aggiornamento (ore)"
                                type="number"
                                fullWidth
                                value={corso?.DurataAggiornamento}
                                onChange={handleChange}
                                variant="outlined"
                                helperText={
                                    validation?.eMail
                                        ? 'Campo obbligatorio'
                                        : ''
                                }
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleSave}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AnagraficaCorsi;

const AttestatoCustomActions = ({
    corso,
    onChange,
    setSnack,
    setOpenSnack,
}) => {
    const [loading, setLoading] = useState(false);
    const fileInputId = `attestato-custom-${String(corso?.Codice || '').replace(
        /[^a-zA-Z0-9_-]/g,
        '_'
    )}`;
    const hasAttestato = !!corso?.AttestatoCustomID;
    const encodedCodice = encodeURIComponent(corso?.Codice || '');

    const notify = (severity, messaggio) => {
        setSnack({ severity, messaggio });
        setOpenSnack(true);
    };

    const getErrorMessage = async (error, fallback) => {
        const data = error?.response?.data;
        if (data instanceof Blob) {
            try {
                const text = await data.text();
                const payload = JSON.parse(text);
                return payload?.message || fallback;
            } catch {
                return fallback;
            }
        }
        return data?.message || fallback;
    };

    const handleUpload = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = null;
        if (!file || loading) {
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        setLoading(true);
        try {
            await unsplash.post(
                `anagraficaCorsi/${encodedCodice}/attestato-custom`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            notify('success', 'Attestato custom caricato con successo');
            await onChange?.();
        } catch (error) {
            notify(
                'error',
                error?.response?.data?.message ||
                    "Errore durante il caricamento dell'attestato custom"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleView = async () => {
        if (!hasAttestato || loading) {
            return;
        }

        setLoading(true);
        try {
            const response = await unsplash.get(
                `anagraficaCorsi/${encodedCodice}/attestato-custom/download`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    responseType: 'blob',
                }
            );
            const blob = new Blob([response.data], {
                type:
                    response.headers?.['content-type'] ||
                    corso.AttestatoCustomMimeType ||
                    'application/pdf',
            });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        } catch (error) {
            notify(
                'error',
                await getErrorMessage(
                    error,
                    "Errore durante l'apertura dell'attestato custom"
                )
            );
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!hasAttestato || loading) {
            return;
        }

        setLoading(true);
        try {
            await unsplash.delete(
                `anagraficaCorsi/${encodedCodice}/attestato-custom`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
            notify('success', 'Attestato custom eliminato con successo');
            await onChange?.();
        } catch (error) {
            notify(
                'error',
                error?.response?.data?.message ||
                    "Errore durante l'eliminazione dell'attestato custom"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
                width: '100%',
            }}
        >
            <input
                id={fileInputId}
                type="file"
                accept="application/pdf,image/png,image/jpeg"
                style={{ display: 'none' }}
                onChange={handleUpload}
            />
            {loading ? (
                <CircularProgress size={22} />
            ) : (
                <>
                    {hasAttestato && (
                        <Tooltip
                            title={
                                corso.AttestatoCustomFilename || 'Visualizza'
                            }
                        >
                            <IconButton size="small" onClick={handleView}>
                                <InsertDriveFileIcon
                                    sx={{ color: '#11526F' }}
                                    fontSize="small"
                                />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Tooltip
                        title={
                            hasAttestato
                                ? 'Sostituisci attestato custom'
                                : 'Carica attestato custom'
                        }
                    >
                        <IconButton
                            size="small"
                            onClick={() =>
                                document.getElementById(fileInputId)?.click()
                            }
                        >
                            <Upload
                                sx={{ color: '#2265B1' }}
                                fontSize="small"
                            />
                        </IconButton>
                    </Tooltip>
                    {hasAttestato && (
                        <Tooltip title="Elimina attestato custom">
                            <IconButton size="small" onClick={handleDelete}>
                                <Delete
                                    sx={{ color: '#FF2768' }}
                                    fontSize="small"
                                />
                            </IconButton>
                        </Tooltip>
                    )}
                </>
            )}
        </Box>
    );
};

const DeleteDialog = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton aria-label="edit" onClick={handleClickOpen}>
                <Delete
                    style={{ height: '2rem', width: '2rem', color: '#FF2768' }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                TransitionComponent={Transition}
            >
                <DialogTitle id="alert-dialog-title" sx={{ mx: 'auto' }}>
                    Sei sicuro di voler eliminare il corso selezionato?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare il seguente
                        Corso :<br />
                        <b>
                            {props.corso.Codice +
                                ' - ' +
                                props.corso.Descrizione}
                        </b>
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button
                        onClick={() => props.myFunction(props.corso.Codice)}
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Box component="div">{children}</Box>
                </Box>
            )}
        </div>
    );
}

const UploadPresenze = () => {
    // result: undefined | "loading" | { error: boolean; message: string; }
    const [result, setResult] = useState(undefined);
    const anchorRef = useRef(null);

    const [openButton, setOpenButton] = useState(false);
    const handleToggleButton = () => {
        setOpenButton(!openButton);
    };

    const options = [
        {
            id: 'download',
            icon: <Download />,
            text: 'SCARICA TEMPLATE',
        },
        {
            id: 'upload',
            icon: <Upload />,
            text: 'IMPORTA',
        },
    ];

    return (
        <>
            {/* button */}
            <ButtonGroup
                variant="contained"
                className="ml-4 ButtonMiller"
                ref={anchorRef}
                aria-label="split button"
            >
                <Button
                    startIcon={<InsertDriveFileIcon />}
                    variant="contained"
                    className="ButtonMiller"
                    onClick={() => {
                        handleToggleButton();
                    }}
                >
                    Carica Storico
                </Button>
                <Button
                    variant="contained"
                    className="ButtonMiller"
                    aria-controls={openButton ? 'split-button-menu' : undefined}
                    aria-expanded={openButton ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={() => {
                        handleToggleButton();
                    }}
                >
                    {openButton ? <ArrowDropUp /> : <ArrowDropDownIcon />}
                </Button>
            </ButtonGroup>

            {/* popper (download / upload) */}
            <Popper
                sx={{
                    zIndex: 100,
                }}
                open={openButton}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps}>
                        <Paper sx={{ ml: '15px' }}>
                            <ClickAwayListener
                                onClickAway={(event) => {
                                    if (
                                        anchorRef.current &&
                                        anchorRef.current.contains(event.target)
                                    ) {
                                        return;
                                    }
                                    setOpenButton(false);
                                }}
                            >
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option}
                                            onClick={(event) => {
                                                if (option.id === 'download') {
                                                    const link =
                                                        document.createElement(
                                                            'a'
                                                        );
                                                    link.href =
                                                        '/templates/presenze.csv';
                                                    link.download =
                                                        'presenze.csv';
                                                    document.body.appendChild(
                                                        link
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                        link
                                                    );
                                                }
                                                if (option.id === 'upload') {
                                                    document
                                                        .getElementById(
                                                            'file_csv'
                                                        )
                                                        .click();
                                                }
                                            }}
                                        >
                                            <span style={{ color: '#11526f' }}>
                                                {option.icon} {option.text}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            {/* dialog */}
            <Dialog
                open={result !== undefined}
                onClose={() => {
                    setResult(undefined);
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    <div
                        className={clsx('w-full text-left ', {
                            'text-green-500': result?.error === false,
                            'text-red-500': result?.error === true,
                        })}
                    >
                        {result?.error === true && <ErrorIcon />}
                        {result?.error === false && <CheckCircleIcon />}
                        {result === 'loading' && 'Caricamento in corso...'}
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="min-w-[300px]">
                        {result?.message ?? ''}

                        {result === 'loading' && (
                            <div className="w-full text-center">
                                <CircularProgress />
                            </div>
                        )}
                    </DialogContentText>
                </DialogContent>
                {result && result !== 'loading' && (
                    <DialogActions>
                        <Button
                            type="button"
                            onClick={() => {
                                setResult(undefined);
                            }}
                            autoFocus
                        >
                            OK
                        </Button>
                    </DialogActions>
                )}
            </Dialog>

            {/* file input (hidden) */}
            <input
                type="file"
                hidden
                accept=".csv"
                name=""
                id="file_csv"
                onChange={async (e) => {
                    if (e.target.files) {
                        setResult('loading');
                        try {
                            const file = e.target.files[0];
                            const formData = new FormData();
                            formData.append('file', file);
                            let responseUpload = await unsplash.post(
                                '/corsi/upload-corsi',
                                formData,
                                {
                                    headers: {
                                        'content-type': 'multipart/form-data',
                                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                    },
                                    timeout: 30 * 60e3, // 30m
                                }
                            );

                            setResult(responseUpload?.data);
                        } catch (error) {
                            setResult({
                                error: true,
                                message:
                                    'Errore durante il caricamento del file',
                            });
                        }

                        // reset file input
                        document.getElementById('file_csv').value = '';
                    }
                }}
            />
        </>
    );
};
